export const restrictions = {
    MAX_GROUPS_PER_CONTACT: 50,
    MAX_NAME_LENGTH: 40,
};
